import {Model} from '@vuex-orm/core';
import UnitPlan from '../../units/UnitPlan';
import UnitPlanWeekIe from './UnitPlanWeekIe';

export default class UnitPlanWeek extends Model {
    static entity = 'unitplan_weeks';

    static fields () {
        return {
            id: this.number(0),
            unitplan_id: this.number(null),
            hours: this.string('00:00'),
            startDate: this.string(''),
            endDate: this.string(''),

            unitplan: this.belongsTo(UnitPlan, 'unitplan_id'),
            ies: this.hasMany(UnitPlanWeekIe, 'unitplanweek_id'),
        };
    }
}
